const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/IconTextTuples.tsx';
import { Icon, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import { CSSProperties, useMemo } from 'react';

export interface IconTextTuple {
    icon: string;
    primaryText: string;
    secondaryText?: string;
}

interface IconTextTuplesProps {
    tuples: IconTextTuple[];
    styleIcon?: CSSProperties;
    styleText?: CSSProperties;
    styleListItem?: CSSProperties;
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            listItemIcon: css`
                min-width: ${theme.spacing(4)};
            `,
        }),
        [theme]
    );
}

export const IconTextTuples = (props: IconTextTuplesProps) => {
    if (props.tuples.length === 0) {
        return null;
    }

    const classes = useCSSClasses();

    return (
        <List disablePadding>
            {props.tuples.map((tuple: IconTextTuple, idx: number) => {
                const { icon, primaryText, secondaryText } = tuple;
                return (
                    <ListItem disableGutters key={idx} style={props.styleListItem}>
                        {icon && (
                            <ListItemIcon className={classes.listItemIcon}>
                                <Icon className={icon} color="primary" style={props.styleIcon} />
                            </ListItemIcon>
                        )}
                        <ListItemText primary={primaryText} secondary={secondaryText} style={props.styleText} />
                    </ListItem>
                );
            })}
        </List>
    );
};
